import {
	nullable,
	randomDate,
	randomName,
	randomNumber,
	randomSentence,
	randomWord,
} from '@rtls/map/util/factory/factory.util';
import * as Factory from 'factory.ts/lib';
import { typeFactory } from '../shared/type.factory';
import { ThingType } from './thing-type.model';

export const thingTypeFactory = Factory.makeFactory<ThingType>({
	id: Factory.each((i) => nullable(i)),
	key: Factory.each(() => nullable(randomName())),
	translation: Factory.each(() => nullable(randomSentence())),
	type: Factory.each(() => typeFactory.build()),
	createdDate: Factory.each(() => nullable(new Date(randomDate()))),
	externalId: Factory.each(() => nullable(randomWord())),
	group: Factory.each(() => nullable(randomNumber())),
	providerId: Factory.each(() => nullable(randomWord())),
	uuid: Factory.each(() => nullable(randomWord())),
	validityInclusiveStartDate: Factory.each(() => nullable('2024-09-01')),
	validityExclusiveEndDate: Factory.each(() => nullable('2024-10-01')),
});
